// extracted by mini-css-extract-plugin
module.exports = {"container":"hC","title":"hD"};